import { render, staticRenderFns } from "./Compounds.vue?vue&type=template&id=7fa5800b&"
import script from "./Compounds.vue?vue&type=script&lang=js&"
export * from "./Compounds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports